import plasmadata from "./raw/plasma.json";

export const PlasmaColorMap = (type) => {
  if (type === "range") {
    return plasmadata;
  }
};
